export * from './KEY_VALUE_PAIR.interface';
export * from './location.base-function';
export * from './permission.base-functions';
export * from './browser-info.base-function';
export * from './temperature.base-function';
export * from './language.base-function';
export * from './battery.base-function';